import { useEffect, useState } from "react";
import { useLocation, useParams, Outlet } from "react-router-dom";

import Header from "./header";
import Sidebar from "./navbar";

import { getLoanSummary } from "@/services/loanservices";

export default function RBFLMSLayout() {
  const location = useLocation();
  const { loanUUID } = useParams();
  const [loanSummary, setLoanSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  // Extract the last path segment → title
  const path = location.pathname.split("/").filter(Boolean).pop() || "dashboard";

  // Convert slug → Title Case
  const pageTitle = path
    .replace(/-/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());

  const fetchLoanSummary = async () => {
    try {
      const res = await getLoanSummary(loanUUID);
      const data = res?.results?.response?.data;

      setLoanSummary(data || null);
    } catch (err) {
      console.error("Error fetching loan summary:", err);
      setLoanSummary(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!loanUUID) return;

    fetchLoanSummary();
  }, [loanUUID]);

  return (
    <section className="flex">
      <Sidebar />
      <section className="flex-1" style={{ background: "#F8F8FB" }}>
        <Header pageTitle={pageTitle} loanUUID={loanUUID} loanSummary={loanSummary} />
        <div className="px-4">
          <Outlet context={{ loanUUID, loanSummary, loading }} />
        </div>
      </section>
    </section>
  );
}
